@if (!loading && dispositivo && vista; as v) {
  <app-breadcrumb
    listado="/main/administracion/dispositivoslorawan"
    etiquetaListado="Dispositivos LoRaWAN"
    [titulo]="dispositivo?.name || dispositivo?.deveui"
  ></app-breadcrumb>

  <!-- Encabezado con la misma estética que las tarjetas de la pestaña Info -->
  <header class="encabezado">
    <div class="encabezado-avatar"><mat-icon>router</mat-icon></div>
    <div class="encabezado-texto">
      <h1>{{ dispositivo.name || dispositivo.deveui }}</h1>
      @if (subtitulo) {
        <span class="encabezado-nombre encabezado-eui">{{ subtitulo }}</span>
      }
      <div class="encabezado-chips">
        @if (dispositivo.tipo) {
          <span class="chip">
            <mat-icon>category</mat-icon>
            {{ dispositivo.tipo }}
          </span>
        }
        @if (dispositivo.cliente?.nombre) {
          <span class="chip">
            <mat-icon>business</mat-icon>
            {{ dispositivo.cliente.nombre }}
          </span>
        }
      </div>
    </div>
    <!-- Mismo permiso que pide el listado para editar -->
    @if (puedeEditar) {
      <button
        irxBotonIcono
        class="encabezado-editar"
        (click)="editar()"
        tooltip="Editar dispositivo"
      >
        <mat-icon>edit</mat-icon>
      </button>
    }
  </header>

  <mat-tab-group
    [(selectedIndex)]="selectedTab"
    (selectedTabChange)="tabChanged($event)"
    class="tabs-detalle"
  >
    <!-- Info -->
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">info</mat-icon>
        <span>Info</span>
      </ng-template>
      <ng-template matTabContent>
        <section class="lorawan-info">
          <!-- Resumen: comunicación y entrega. La identidad (nombre, DevEUI,
               tipo, cliente) está en el encabezado. -->
          <app-dt-card>
            <app-dt-datos destacado>
              <app-dt-dato etiqueta="Comunicación" ocultarVacio>
                <app-dt-estado
                  [tono]="v.comunicacion.tono"
                  [etiqueta]="v.comunicacion.etiqueta"
                />
              </app-dt-dato>
              <app-dt-dato
                etiqueta="Última comunicación"
                [valor]="v.hace ? 'hace ' + v.hace : null"
              >
                @if (v.ultimaComunicacion) {
                  <span class="dt-muted lorawan-fecha">
                    {{ v.ultimaComunicacion }}
                  </span>
                }
              </app-dt-dato>
              <app-dt-dato etiqueta="Señal" [valor]="v.senal" />
              <app-dt-dato etiqueta="Tasa de entrega" ocultarVacio>
                @if (v.entrega; as e) {
                  <app-dt-estado [tono]="e.tono" [etiqueta]="e.etiqueta" />
                } @else {
                  <span class="dt-vacio">Sin información</span>
                }
              </app-dt-dato>
            </app-dt-datos>
          </app-dt-card>

          <!-- Grilla de 3 × 2: cada fila toma el alto de su tarjeta más
               alta, así los bordes coinciden (pedido del usuario). -->
          <div class="lorawan-grilla">
            <app-dt-card titulo="Equipo" icono="memory">
              <ng-container
                *ngTemplateOutlet="datos; context: { $implicit: v.equipo }"
              ></ng-container>
            </app-dt-card>

            <app-dt-card titulo="Comunicación" icono="cell_tower">
              <ng-container
                *ngTemplateOutlet="
                  datos;
                  context: { $implicit: v.comunicacionFilas }
                "
              ></ng-container>
            </app-dt-card>

            <app-dt-card titulo="Último comando" icono="send">
              @if (v.comando; as c) {
                <app-dt-datos>
                  <app-dt-dato etiqueta="Estado" ocultarVacio>
                    <app-dt-estado [tono]="c.tono" [etiqueta]="c.estado" />
                  </app-dt-dato>
                  @for (f of c.filas; track f.etiqueta) {
                    <app-dt-dato
                      [etiqueta]="f.etiqueta"
                      [valor]="f.valor"
                      [mono]="!!f.mono"
                    />
                  }
                </app-dt-datos>
              } @else {
                <span class="dt-muted">Sin comandos enviados</span>
              }
            </app-dt-card>

            <!-- Relación por deveui, como la columna del listado -->
            <app-dt-card titulo="Asignado a" icono="lightbulb">
              @if (cargandoLuminaria) {
                <span class="dt-muted">Cargando…</span>
              } @else if (luminaria) {
                <app-dt-datos>
                  <app-dt-dato
                    etiqueta="Luminaria"
                    [valor]="luminaria.identificacion || luminaria.deveui"
                  >
                    <button
                      irxBotonIcono
                      tamano="mini"
                      (click)="verLuminaria()"
                      tooltip="Ver detalle de la luminaria"
                    >
                      <mat-icon>visibility</mat-icon>
                    </button>
                  </app-dt-dato>
                  <app-dt-dato
                    etiqueta="Puesta"
                    [valor]="luminaria.puesta?.identificacion || 'Sin puesta'"
                  />
                </app-dt-datos>
              } @else {
                <span class="dt-muted">Sin asignar</span>
              }
            </app-dt-card>

            <app-dt-card titulo="Paquetes" icono="inventory_2">
              <ng-container
                *ngTemplateOutlet="datos; context: { $implicit: v.paquetes }"
              ></ng-container>
            </app-dt-card>

            @if (v.configuracion.length) {
              <app-dt-card titulo="Configuración" icono="tune">
                <ng-container
                  *ngTemplateOutlet="
                    datos;
                    context: { $implicit: v.configuracion }
                  "
                ></ng-container>
              </app-dt-card>
            }
          </div>
        </section>
      </ng-template>
    </mat-tab>

    <!-- Historial reportes de estado -->
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">description</mat-icon>
        <span>Reportes de estado</span>
      </ng-template>
      <ng-template matTabContent>
        @if (tiposReporteEstado.length) {
          <app-listado-reportes-genericos
            [entidad]="dispositivo"
            tipoEntidad="DispositivoLorawan"
            [tipoValoresReporte]="tiposReporteEstado"
          ></app-listado-reportes-genericos>
        } @else {
          <app-empty-state
            icon="inbox"
            message="Este tipo de dispositivo no tiene reportes de estado"
          ></app-empty-state>
        }
      </ng-template>
    </mat-tab>

    <!-- Historial reportes de consumo -->
    @if (esConConsumo) {
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class="tab-icon">bolt</mat-icon>
          <span>Reportes de consumo</span>
        </ng-template>
        <ng-template matTabContent>
          <app-listado-reportes-genericos
            [entidad]="dispositivo"
            tipoEntidad="DispositivoLorawan"
            [tipoValoresReporte]="tiposReporteConsumo"
          ></app-listado-reportes-genericos>
        </ng-template>
      </mat-tab>
    }

    <!-- Métricas de downlinks -->
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">analytics</mat-icon>
        <span>Métricas de downlinks</span>
      </ng-template>
      <ng-template matTabContent>
        <app-detalle-metricas-downlinks
          [deveui]="dispositivo.deveui"
        ></app-detalle-metricas-downlinks>
      </ng-template>
    </mat-tab>

    <!-- Fila del NS. Sólo nivel 0: es estado interno del network server y el
         botón que la acompaña borra downlinks. El backend lo exige igual
         (Nivel0Guard); esconder la solapa evita ofrecer un 403. -->
    @if (esNivel0) {
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class="tab-icon">playlist_remove</mat-icon>
          <span>Fila de downlinks (NS)</span>
        </ng-template>
        <ng-template matTabContent>
          <app-fila-ns [idDispositivo]="dispositivo._id!"></app-fila-ns>
        </ng-template>
      </mat-tab>
    }
  </mat-tab-group>
} @else if (!loading && noEncontrado) {
  <app-breadcrumb
    listado="/main/administracion/dispositivoslorawan"
    etiquetaListado="Dispositivos LoRaWAN"
    [titulo]="dispositivo?.name || dispositivo?.deveui"
  ></app-breadcrumb>
  <app-empty-state
    icon="router"
    message="No se encontró el dispositivo"
  ></app-empty-state>
} @else {
  <app-detalle-esqueleto
    icono="router"
    listado="/main/administracion/dispositivoslorawan"
    etiquetaListado="Dispositivos LoRaWAN"
    [pestanas]="5"
  ></app-detalle-esqueleto>
}

<!-- Una fila de datos (Equipo, Comunicación, Paquetes, Configuración) -->
<ng-template #datos let-filas>
  <app-dt-datos>
    @for (f of filas; track f.etiqueta) {
      <app-dt-dato
        [etiqueta]="f.etiqueta"
        [valor]="f.valor"
        [mono]="!!f.mono"
        [copiable]="!!f.copiable"
      />
    }
  </app-dt-datos>
</ng-template>
